function injectStyle (context) {
  require("!!../../../../node_modules/.pnpm/extract-text-webpack-plugin@3.0.2_webpack@3.12.0/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/.pnpm/vue-loader@14.2.4_@vue+compiler-sfc@3.5.22_babel-core@6.26.3_css-loader@0.28.11_ejs@3.1_6f968ca4c533e95c4b15992b3d6c185d/node_modules/vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"id\":\"data-v-02f46d84\",\"scoped\":true,\"sourceMap\":false}!less-loader?{\"sourceMap\":true}!../../../../node_modules/.pnpm/vue-loader@14.2.4_@vue+compiler-sfc@3.5.22_babel-core@6.26.3_css-loader@0.28.11_ejs@3.1_6f968ca4c533e95c4b15992b3d6c185d/node_modules/vue-loader/lib/selector?type=styles&index=0!./statement.vue")
}
/* script */
export * from "!!babel-loader!../../../../node_modules/.pnpm/vue-loader@14.2.4_@vue+compiler-sfc@3.5.22_babel-core@6.26.3_css-loader@0.28.11_ejs@3.1_6f968ca4c533e95c4b15992b3d6c185d/node_modules/vue-loader/lib/selector?type=script&index=0!./statement.vue"
import __vue_script__ from "!!babel-loader!../../../../node_modules/.pnpm/vue-loader@14.2.4_@vue+compiler-sfc@3.5.22_babel-core@6.26.3_css-loader@0.28.11_ejs@3.1_6f968ca4c533e95c4b15992b3d6c185d/node_modules/vue-loader/lib/selector?type=script&index=0!./statement.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../../node_modules/.pnpm/vue-loader@14.2.4_@vue+compiler-sfc@3.5.22_babel-core@6.26.3_css-loader@0.28.11_ejs@3.1_6f968ca4c533e95c4b15992b3d6c185d/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-02f46d84\",\"hasScoped\":true,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../../node_modules/.pnpm/vue-loader@14.2.4_@vue+compiler-sfc@3.5.22_babel-core@6.26.3_css-loader@0.28.11_ejs@3.1_6f968ca4c533e95c4b15992b3d6c185d/node_modules/vue-loader/lib/selector?type=template&index=0!./statement.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02f46d84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../node_modules/.pnpm/vue-loader@14.2.4_@vue+compiler-sfc@3.5.22_babel-core@6.26.3_css-loader@0.28.11_ejs@3.1_6f968ca4c533e95c4b15992b3d6c185d/node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/statement.vue
// module id = null
// module chunks = 